export const PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.])[A-Za-z\d@$!%*?&.]{8,25}$/;
export const TEL_PATTERN= /^(?:\+57)?(?:(?:3[0-2]\d|60\d|800|900)\d{7}|\d{7})$/

